import React, { useEffect, useState, useRef } from 'react'
import axios, {AxiosResponse} from 'axios';
import "react-datepicker/dist/react-datepicker.css";
import { Api } from "../../../../helpers/Api";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from '../Spinner/LoadingSpinner';
import { connect } from "react-redux";
import { jsPDF } from "jspdf";
import Blob from "blob";
import html2canvas from 'html2canvas';
import { Dropdown } from 'react-bootstrap';
import { option } from '../../../../helpers/DropDownOption';
import htmlDocx from 'html-docx-js/dist/html-docx';
import { saveAs } from 'file-saver';


const headLogo = {
  position: 'absolute',
  width: '100px',
  height: '40px',
  top: 0,
  left: '3%',
}

const headName = {
  position: 'absolute',
  top: 0,
  textAlign: 'center',
  left: '30%',
}

const headingTabledata = {
  marginLeft: 'auto',
  marginRight: 'auto',
  border: '.5px solid black'
}

const tabledata = {
  marginLeft: 'auto',
  marginRight: 'auto',
  borderLeft: '.5px solid black',
  borderRight: '.5px solid black',
  borderBottom: '.5px solid black'
}

const normalText = {
  textAlign: 'justify',
  fontSize: '2.27vh',
  padding: '10px'
}

const table = {
  width: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginBottom: "30px",
  minHeight: "387px"
}

const td = {
  fontSize: '2.27vh',
  width: '150px',
  padding: '10px',
  borderRight: '.5px solid black',
}

const textAlign = {
  textAlign: 'left',
  fontSize: '2.27vh',
  padding: '10px',
}

const HeadingAligne = {
  fontSize:'2.27vh',
  textAlign: 'center',
  fontWeight: 'bold',
}

const justifyAlign = {
  fontSize: '2.27vh',
  textAlign: 'justify'
}

const pageCss = {
  position: 'absolute',
  fontSize: '2.27vh',
  bottom: 0,
  right: 2,
}

const eventName = {
  position: 'absolute',
  fontSize: '2.27vh',
  bottom: 0,
  left: 2,
}

const EventReport = ({ user, ...props }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [count, setCount] = useState(0);
  const params = useParams();
  const navigate = useNavigate();

  const loadData = (id) => {
    if (id === 'new') {
      return;
    }

    Api.call(`/getReport/${id}`).then(post => {
      setData(post)
      dataSet(post)
      setTimeout(() => {
      }, 2000)
    }).catch(console.log).finally(() => {

    });
  };


  const dataSet = async(data)=>{
    const srcs = [];
    let imagecount = 0; 
    data?.EventsPhotos?.forEach(element => {
        axios.get(element?.imageUrl.replace("itmatic.io", "codebrigade.in"), { responseType: 'blob' }).then((response) => {
          return response.data;
      })
      .then((blob) => {
        const reader = new FileReader();

        // Use a promise to handle FileReader
        return new Promise((resolve, reject) => {
            reader.onloadend = () => {
                resolve(reader.result); // Base64 string
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob); // Read the Blob as Base64
        });
    })
    .then((base64String) => {
        var key = element?.imageUrl
      srcs[key]={"url":base64String,"caption":element?.caption};
      imagecount++;
      if (imagecount ==  data?.EventsPhotos?.length) {
        setImages(srcs);
        setCount(imagecount);
    }
    })
      .catch((error) => {
          console.error('Error fetching the image:', error);
      })
   });
  }
  
  useEffect(() => {
    window.resizeTo(100, 100);
    if (!user.user) {
      navigate(`/`);
    }
    else if (params.id) {
      loadData(params.id)
    }
  }, [params.id])

  const nl2br = (str = '', is_xhtml) => {
    if (typeof str === 'undefined' || str === null) {
      return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    str = (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    return str;
  }

  useEffect(() => {
    if (count>0) {
      document.getElementById("outcomes").innerHTML = nl2br(data?.outcomes);
      document.getElementById("Objective").innerHTML = nl2br(data?.objective);
    }
  }, [data?.outcomes, data?.objective,count])


  const getData = (dat, index) => {
    return <tr style={tabledata}>
      {Object.keys(dat).map(column => {
        return <td style={td}>{data.Attendances[index][column]}</td>
      })}
    </tr>
  };

  const fetchLogoAsBase64 = async () => {
    try {
      const response = await fetch(window.location.origin + '/images/Chitkara.png');
      if (!response.ok) throw new Error('Network response was not ok');
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error loading logo from public path, trying fallback relative path:", error);
      try {
        const response = await fetch('../../../../images/Chitkara.png');
        if (!response.ok) throw new Error('Fallback response was not ok');
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      } catch (err) {
        console.error("Fallback error loading logo:", err);
        return '';
      }
    }
  };

  const wordFormat = async () => {
    const logoBase64 = await fetchLogoAsBase64();

    let headerRightHtml = `<div style="font-size: 12pt; font-weight: bold; font-family: Calibri, Arial, sans-serif; color: black; margin-bottom: 2px;">${data?.template?.department?.name || ''}</div>`;
    
    let showBrand = true;
    let startDate = new Date(data?.template?.start_date);
    let FistOfJuly = new Date(2025, 6, 1);
    if (startDate > FistOfJuly && data?.template?.department?.id == 39) {
      showBrand = false;
    }
    if (showBrand && data?.template?.brand?.name && data?.template?.department?.name?.trim() !== data?.template?.brand?.name?.trim()) {
      headerRightHtml += `<div style="font-size: 11pt; font-family: Calibri, Arial, sans-serif; color: black;">${data?.template?.brand?.name}</div>`;
    }

    // 1. Construct Event Details Table HTML
    let eventDetailsRows = `
      <tr>
        <th colspan="2" style="border-bottom: 1px solid #000000; padding: 10px; text-align: center; font-family: Calibri, Arial, sans-serif; font-size: 11pt; font-weight: bold; background-color: #f2f2f2;">EVENT DETAILS</th>
      </tr>
      <tr>
        <td style="width: 150px; border-right: 1px solid #000000; border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt; font-weight: bold;">EVENT TYPE</td>
        <td style="border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt;">${data?.template.secoundType ? data?.template.secoundType?.toUpperCase() : data?.template?.type?.toUpperCase()}</td>
      </tr>
      <tr>
        <td style="width: 150px; border-right: 1px solid #000000; border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt; font-weight: bold;">TOPIC</td>
        <td style="border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt;">${data?.template?.name?.toUpperCase()}</td>
      </tr>
      <tr>
        <td style="width: 150px; border-right: 1px solid #000000; border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt; font-weight: bold;">DATE</td>
        <td style="border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt;">${data?.template?.start_date?.toUpperCase()} to ${data?.template?.end_date?.toUpperCase()}</td>
      </tr>
      <tr>
        <td style="width: 150px; border-right: 1px solid #000000; border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt; font-weight: bold;">MODE</td>
        <td style="border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt;">${data?.template?.location?.toUpperCase()}</td>
      </tr>
    `;

    if (data?.template?.address_line_2) {
      eventDetailsRows += `
        <tr>
          <td style="width: 150px; border-right: 1px solid #000000; border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt; font-weight: bold;">VENUE</td>
          <td style="border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt;">${data?.template?.address_line_2?.toUpperCase()}${data?.template?.address_line_1 ? ` (${data?.template?.address_line_1?.toUpperCase()})` : ""}</td>
        </tr>
      `;
    }

    eventDetailsRows += `
      <tr>
        <td style="width: 150px; border-right: 1px solid #000000; border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt; font-weight: bold;">ORGANIZER NAME</td>
        <td style="border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt;">${data?.template?.organized_by?.toUpperCase()}</td>
      </tr>
    `;

    if (data?.template?.resource_persons && data?.template?.resource_persons[0]['name'] !== "") {
      const resourcePersonsText = data?.template?.resource_persons?.map((d, index) =>
        index === data?.template?.resource_persons?.length - 1 ? `${d.name?.toUpperCase()}, ${d.designation?.toUpperCase()}` : `${d.name?.toUpperCase()}, ${d.designation?.toUpperCase()} | `
      ).join('');
      eventDetailsRows += `
        <tr>
          <td style="width: 150px; border-right: 1px solid #000000; border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt; font-weight: bold;">RESOURCE PERSON</td>
          <td style="border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt;">${resourcePersonsText}</td>
        </tr>
      `;
    }

    eventDetailsRows += `
      <tr>
        <td style="width: 150px; border-right: 1px solid #000000; border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt; font-weight: bold;">NO. OF PARTICIPANTS</td>
        <td style="border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt;">${data?.participants ? data.participants : data?.template?.registrations?.length}</td>
      </tr>
    `;

    if (data?.template?.sdg) {
      const sdgText = data?.template?.sdg?.map((d, index) =>
        index === data?.template?.sdg?.length - 1 ? `${d.label.toUpperCase()}` : `${d.label.toUpperCase()},  `
      ).join('');
      eventDetailsRows += `
        <tr>
          <td style="width: 150px; border-right: 1px solid #000000; border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt; font-weight: bold;">SDG NO</td>
          <td style="border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt;">${sdgText}</td>
        </tr>
      `;
    }

    if (data?.template?.PO) {
      const poText = data?.template?.PO?.map((d, index) =>
        index === data?.template?.PO?.length - 1 ? `${d.label.toUpperCase()}` : `${d.label.toUpperCase()},  `
      ).join('');
      eventDetailsRows += `
        <tr>
          <td style="width: 150px; border-right: 1px solid #000000; border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt; font-weight: bold;">PO number(s)</td>
          <td style="border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt;">${poText}</td>
        </tr>
      `;
    }

    if (data?.template?.Charter) {
      const charterHtml = data?.template?.Charter?.map((d, index) => {
        const label = d.label;
        const spans = label.split(" ").map(char => {
          if (option.KeywordCharter.includes(char)) {
            return `<span style="color: red;">${char}</span>`;
          }
          return char;
        }).join(" ");
        return `<span>${spans}${index === data?.template?.Charter?.length - 1 ? "" : ", "}</span>`;
      }).join('');

      eventDetailsRows += `
        <tr>
          <td style="width: 150px; border-right: 1px solid #000000; border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt; font-weight: bold;">University Charter</td>
          <td style="border-bottom: 1px solid #000000; padding: 10px; font-family: Calibri, Arial, sans-serif; font-size: 11pt;">${charterHtml}</td>
        </tr>
      `;
    }

    // 2. Construct Image Gallery Table HTML
    let imagesHtml = '';
    if (data?.EventsPhotos && count > 0) {
      imagesHtml += `
        <h5 style="font-family: Calibri, Arial, sans-serif; font-size: 12pt; font-weight: bold; margin-top: 25px; margin-bottom: 10px;">EVENT IMAGES</h5>
        <table style="width: 100%; border-collapse: collapse; border: none; margin-bottom: 25px;">
      `;
      for (let i = 0; i < data.EventsPhotos.length && i < 6; i += 2) {
        imagesHtml += '<tr>';
        for (let j = 0; j < 2; j++) {
          const index = i + j;
          if (index < data.EventsPhotos.length && index < 6) {
            const element = data.EventsPhotos[index];
            const imgData = images[element?.imageUrl];
            if (imgData) {
              imagesHtml += `
                <td style="width: 50%; border: none; padding: 10px; text-align: center; vertical-align: top;">
                  <img src="${imgData.url}" style="width: 320px; height: 240px; object-fit: cover;" width="320" height="240" />
                  <p style="font-family: Calibri, Arial, sans-serif; font-size: 10pt; margin-top: 5px; text-align: center; color: #555555;">${element?.caption || ''}</p>
                </td>
              `;
            } else {
              imagesHtml += '<td style="width: 50%; border: none; padding: 10px;"></td>';
            }
          } else {
            imagesHtml += '<td style="width: 50%; border: none; padding: 10px;"></td>';
          }
        }
        imagesHtml += '</tr>';
      }
      imagesHtml += '</table>';
    }

    // 3. Construct Attendance Table HTML
    let attendanceHtml = '';
    if (data?.Attendances && data.Attendances.length > 0) {
      const columns = Object.keys(data.Attendances[0]);
      attendanceHtml += `
        <h5 style="font-family: Calibri, Arial, sans-serif; font-size: 12pt; font-weight: bold; margin-top: 25px; margin-bottom: 10px;">PARTICIPANTS ATTENDANCE</h5>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #000000; margin-bottom: 25px;">
          <thead>
            <tr style="background-color: #f2f2f2;">
      `;
      columns.forEach(col => {
        attendanceHtml += `<th style="border: 1px solid #000000; padding: 8px; font-family: Calibri, Arial, sans-serif; font-size: 11pt; font-weight: bold; text-align: center;">${col}</th>`;
      });
      attendanceHtml += `
            </tr>
          </thead>
          <tbody>
      `;
      data.Attendances.forEach((attRow) => {
        attendanceHtml += '<tr>';
        columns.forEach(col => {
          attendanceHtml += `<td style="border: 1px solid #000000; padding: 8px; font-family: Calibri, Arial, sans-serif; font-size: 11pt; text-align: left;">${attRow[col] || ''}</td>`;
        });
        attendanceHtml += '</tr>';
      });
      attendanceHtml += `
          </tbody>
        </table>
      `;
    }

    // Get outcomes and objective html content directly to preserve formatting/line-breaks
    const objectiveContent = document.getElementById("Objective") ? document.getElementById("Objective").innerHTML : '';
    const outcomesContent = document.getElementById("outcomes") ? document.getElementById("outcomes").innerHTML : '';

    // 4. Assemble the whole HTML content
    const htmlContent = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <meta charset="utf-8" />
          <!--[if gte mso 9]>
          <xml>
            <w:WordDocument>
              <w:View>Print</w:View>
              <w:Zoom>100</w:Zoom>
            </w:WordDocument>
          </xml>
          <![endif]-->
          <style>
            @page Section1 {
              size: A4;
              margin: 0.5in 0.75in 0.75in 0.75in;
              mso-header-margin: 0.2in;
              mso-header: h1;
            }
            div.Section1 { 
              page: Section1; 
            }
            body {
              font-family: Calibri, Arial, sans-serif;
              font-size: 11pt;
              line-height: 1.2;
            }
            h5 {
              font-family: Calibri, Arial, sans-serif;
              font-size: 12pt;
              font-weight: bold;
              margin-top: 20px;
              margin-bottom: 5px;
            }
            p {
              font-family: Calibri, Arial, sans-serif;
              font-size: 11pt;
              margin-top: 0;
              margin-bottom: 10px;
              text-align: justify;
            }
            table#hrdftrtbl {
              margin: 0in 0in 0in 9in;
              width: 1px;
              height: 1px;
              overflow: hidden;
            }
          </style>
        </head>
        <body>
          <div class="Section1">
            <!-- Body content -->
            <table style="width: 100%; border-collapse: collapse; border: 1px solid #000000; margin-bottom: 25px;">
              <tbody>
                ${eventDetailsRows}
              </tbody>
            </table>

            <h5 style="font-family: Calibri, Arial, sans-serif; font-size: 12pt; font-weight: bold; margin-top: 20px; margin-bottom: 5px;">OBJECTIVE:</h5>
            <div style="font-family: Calibri, Arial, sans-serif; font-size: 11pt; margin-left: 10px; margin-bottom: 20px; text-align: justify;">${objectiveContent}</div>

            ${data?.Description ? `
              <h5 style="font-family: Calibri, Arial, sans-serif; font-size: 12pt; font-weight: bold; margin-top: 20px; margin-bottom: 5px;">DESCRIPTION:</h5>
              <p style="font-family: Calibri, Arial, sans-serif; font-size: 11pt; margin-left: 10px; margin-bottom: 20px; text-align: justify; white-space: pre-wrap;">${data.Description}</p>
            ` : ''}

            <h5 style="font-family: Calibri, Arial, sans-serif; font-size: 12pt; font-weight: bold; margin-top: 20px; margin-bottom: 5px;">OUTCOMES:</h5>
            <div style="font-family: Calibri, Arial, sans-serif; font-size: 11pt; margin-left: 10px; margin-bottom: 20px; text-align: justify;">${outcomesContent}</div>

            ${(imagesHtml || attendanceHtml) ? `
              <div style="page-break-before: always;">
                ${imagesHtml}
                ${attendanceHtml}
              </div>
            ` : ''}

            <!-- Header mapping for every page (placed inside Section1 at the very end to force Word mapping and stripping from body flow) -->
            <table id="hrdftrtbl" border="0" cellspacing="0" cellpadding="0">
              <tr>
                <td>
                  <div style="mso-element:header" id="h1">
                    <table style="width: 100%; border-collapse: collapse; border: none; margin-bottom: 5px;">
                      <tr>
                        <td style="width: 110px; border: none; padding: 0; vertical-align: middle;">
                          ${logoBase64 ? `<img src="${logoBase64}" style="width: 100px; height: 40px;" width="100" height="40" />` : ''}
                        </td>
                        <td style="border: none; padding: 0 0 0 15px; text-align: center; vertical-align: middle;">
                          ${headerRightHtml}
                        </td>
                      </tr>
                    </table>
                    <div style="border-top: 1.5px solid #000000; margin-bottom: 10px;"></div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </body>
      </html>
    `;

    const blob = htmlDocx.asBlob(htmlContent);
    const filename = data?.template?.name ? data?.template?.name + '.docx' : 'document.docx';
    saveAs(blob, filename);
  }

  const arrayBufferToBase64 = (buffer) =>{
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
        return btoa(binary); 
  }


  const converPdfDevisionWise = async() => {
    setLoading(true);
    let total = 2;
    if(data?.Attendances){
      total = 3;
    }

      const doc = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 190;
      const pageHeight = 295;
      const firstDivCanvas = await html2canvas(document.getElementById('firstDivision'),{scale: 1, 
        width: window.innerWidth/1.365,
        height: document.getElementById('firstDivision').offsetHeight});
      const firstDivImgData = firstDivCanvas.toDataURL('image/png');
      const firstDivHeight = (firstDivCanvas.height * (imgWidth)) / (firstDivCanvas.width);

          var img = new Image();
          img.src = '../../../../images/Chitkara.png';
          doc.addImage(img, 'png', 8, 9, 37, 14)
          doc.setFontSize(12);
          doc.setTextColor(0);
          PdfHeader(doc);
          doc.setFontSize(8);
          doc.setTextColor(0);

          doc.text(doc.internal.pageSize.getWidth() - 24, doc.internal.pageSize.getHeight() - 2, `Page ${1} of ${total}`);
          doc.setFontSize(7);
          doc.setTextColor(0);
          doc.text(5, doc.internal.pageSize.getHeight() - 2, `${data?.template?.name}(${data?.template?.start_date} to ${data?.template?.end_date})`);
          doc.addImage(firstDivImgData, 'PNG', 10, 28, imgWidth, firstDivHeight);
          // -----------------------------------------------------------------------
          const secoundDivCanvas = await html2canvas(document.getElementById('SecoundDevision'),{scale: 1, 
            width: window.innerWidth/1.365,
            height: document.getElementById('SecoundDevision').offsetHeight});
          const secoundDivImgData = secoundDivCanvas.toDataURL('image/png');
          const secoundDivHeight = (secoundDivCanvas.height * (imgWidth*1.18)) / secoundDivCanvas.width;

          doc.addPage();
          img.src = '../../../../images/Chitkara.png';
          doc.addImage(img, 'png', 8, 9, 37, 14)
          doc.setFontSize(12);
          doc.setTextColor(0);
          PdfHeader(doc);
          doc.setFontSize(8);
          doc.setTextColor(0);

          doc.text(doc.internal.pageSize.getWidth() - 24, doc.internal.pageSize.getHeight() - 2, `Page ${2} of ${total}`);
          doc.setFontSize(7);
          doc.setTextColor(0);
          doc.text(5, doc.internal.pageSize.getHeight() - 2, `${data?.template?.name}(${data?.template?.start_date} to ${data?.template?.end_date})`);
          doc.addImage(secoundDivImgData, 'PNG', 10, 40, imgWidth, secoundDivHeight);


          //-----------------------------------------------------------------------------------
          if (data?.Attendances) {
            // Capture the element as a canvas
            const originalCanvas = await html2canvas(document.getElementById('ThirdDecvision'), {
              scale: 1, 
              width: window.innerWidth/1.365,
              height: document.getElementById('firstDivision').offsetHeight - 30
            });
            
            // Get page dimensions
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
          
            // Calculate image dimensions while maintaining aspect ratio
            const imgWidth = pageWidth - 20; // leaving some margin
            const aspectRatio = originalCanvas.height / originalCanvas.width;
            const imgHeight = imgWidth * aspectRatio;
          
            // Define the half heights
            const halfHeight = originalCanvas.height / 2;
          
            // Create two new canvases for the top and bottom halves
            const canvasTop = document.createElement('canvas');
            const canvasBottom = document.createElement('canvas');
          
            // Set canvas dimensions
            canvasTop.width = originalCanvas.width;
            canvasTop.height = halfHeight;
            canvasBottom.width = originalCanvas.width;
            canvasBottom.height = halfHeight;
          
            const ctxTop = canvasTop.getContext('2d');
            const ctxBottom = canvasBottom.getContext('2d');
          
            // Draw the top half of the original canvas onto canvasTop
            ctxTop.drawImage(originalCanvas, 0, 0, originalCanvas.width, halfHeight, 0, 0, canvasTop.width, canvasTop.height);
          
            // Draw the bottom half of the original canvas onto canvasBottom
            ctxBottom.drawImage(originalCanvas, 0, halfHeight, originalCanvas.width, halfHeight, 0, 0, canvasBottom.width, canvasBottom.height);
          
            // Convert both halves to data URLs
            const topImgData = canvasTop.toDataURL('image/png');
            const bottomImgData = canvasBottom.toDataURL('image/png');
          
            // Add the top half image to the first page of the PDF
            doc.addPage();
            var img = new Image();
            img.src = '../../../../images/Chitkara.png';
            doc.addImage(img, 'png', 8, 9, 37, 14)
            doc.setFontSize(12);
            doc.setTextColor(0);
            PdfHeader(doc);
            doc.setFontSize(8);
            doc.setTextColor(0);
  
            doc.text(doc.internal.pageSize.getWidth() - 24, doc.internal.pageSize.getHeight() - 5, `Page ${1} of ${total}`);
            doc.setFontSize(7);
            doc.setTextColor(0);
            doc.text(5, doc.internal.pageSize.getHeight() - 5, `${data?.template?.name}(${data?.template?.start_date} to ${data?.template?.end_date})`);
            doc.setFontSize(8);
            doc.setTextColor(0);
            let currentPage = doc.internal.getNumberOfPages();
            doc.text(doc.internal.pageSize.getWidth() - 24, doc.internal.pageSize.getHeight() - 5, `Page ${currentPage} of ${total}`);
            doc.setFontSize(7);
            doc.setTextColor(0);
            doc.text(5, doc.internal.pageSize.getHeight() - 5, `${data?.template?.name}(${data?.template?.start_date} to ${data?.template?.end_date})`);
            const topAspectRatio = canvasTop.height / canvasTop.width;
            const topImgHeight = imgWidth * topAspectRatio;
            doc.addImage(topImgData, 'PNG', 10, 40, imgWidth, topImgHeight);
          
            // Add the bottom half image to the next page of the PDF
            doc.addPage();
            var img = new Image();
            img.src = '../../../../images/Chitkara.png';
            doc.addImage(img, 'png', 8, 9, 37, 14)
            doc.setFontSize(12);
            doc.setTextColor(0);
            PdfHeader(doc);
            doc.setFontSize(8);
            doc.setTextColor(0);
  
            doc.text(doc.internal.pageSize.getWidth() - 24, doc.internal.pageSize.getHeight() - 5, `Page ${1} of ${total}`);
            doc.setFontSize(7);
            doc.setTextColor(0);
            doc.text(5, doc.internal.pageSize.getHeight() - 5, `${data?.template?.name}(${data?.template?.start_date} to ${data?.template?.end_date})`);
          
            const bottomAspectRatio = canvasBottom.height / canvasBottom.width;
            const bottomImgHeight = imgWidth * bottomAspectRatio;
            doc.addImage(bottomImgData, 'PNG', 10, 40, imgWidth, bottomImgHeight);
          
            // Add footer and other text (if needed)
            doc.setFontSize(8);
            doc.setTextColor(0);
            currentPage = doc.internal.getNumberOfPages();
            doc.text(doc.internal.pageSize.getWidth() - 24, doc.internal.pageSize.getHeight() - 5, `Page ${currentPage} of ${total}`);
            doc.setFontSize(7);
            doc.setTextColor(0);
            doc.text(5, doc.internal.pageSize.getHeight() - 5, `${data?.template?.name}(${data?.template?.start_date} to ${data?.template?.end_date})`);
          }
          
          // Save the PDF with the template name
          doc.save(`${data?.template?.name}`);
          setLoading(false);
  }

  const PdfHeader = (doc) => {
    console.log(data?.template?.department);
    let startDate = new Date(data?.template?.start_date);
    let FistOfJuly = new Date(2025, 6, 1); 
    doc.text(doc.internal.pageSize.getWidth() / 1.8, 12, `${data?.template?.department?.name}`, {
      color: "black",
      align: 'center',
    });
    if(startDate > FistOfJuly && data?.template?.department.id == 39){
        return;
    }
    if (data?.template?.department?.name.trim() != data?.template?.brand?.name.trim()) {
      doc.text(doc.internal.pageSize.getWidth() / 1.8, 21, `${data?.template?.brand?.name}`, {
        color: "black",
        align: 'center',
      });
    }
  }

  if (count>0) {
    return (<div className='container w-75 p-3' >
      <div className='Form-buttons mt-1'>
        <button type="button" className='cancel mb-2' onClick={async () => { setLoading(true); await wordFormat(); setLoading(false); }}>Word Format</button>
        <button type="button" onClick={converPdfDevisionWise} className='cancel mb-2'>{loading ? 'PleaseWait...' : 'Download'}</button>
      </div>
      <div id="page" >

        {/* /----------------------------------------------------------------------------/ */}

        <div id="firstDivision">
          <table style={table}>

            <tr style={headingTabledata}>
              <th colspan="2" style={HeadingAligne}>EVENT DETAILS</th>
            </tr>

            <tr style={tabledata}>
              <td style={td}>EVENT TYPE</td>
              <td style={textAlign}>{data?.template.secoundType ? data?.template.secoundType?.toUpperCase() : data?.template?.type?.toUpperCase()}</td>
            </tr>

            <tr style={tabledata}>
              <td style={td}>TOPIC</td>
              <td style={textAlign}>{data?.template?.name?.toUpperCase()}</td>
            </tr>

            <tr style={tabledata}>
              <td style={td}>DATE</td>
              <td style={textAlign}>{data?.template?.start_date?.toUpperCase()} to {data?.template?.end_date?.toUpperCase()}</td>
            </tr>

            <tr style={tabledata}>
              <td style={td}>MODE</td>
              <td style={textAlign}>{data?.template?.location?.toUpperCase()}</td>
            </tr>


            {data?.template?.address_line_2 && <tr style={tabledata}>
              <td style={td}>VENUE</td>
              <td style={textAlign}> {data?.template?.address_line_2?.toUpperCase()}{data?.template?.address_line_1 ?` (${data?.template?.address_line_1?.toUpperCase()})`:""}</td>
            </tr>}

            <tr style={tabledata}>
              <td style={td} >ORGANIZER NAME</td>
              <td style={normalText}>{data?.template?.organized_by?.toUpperCase()}</td>
            </tr>

            {data.template.resource_persons && data?.template?.resource_persons[0]['name'] != "" && <tr style={tabledata}>
              <td style={td} >RESOURCE PERSON</td>
              <td style={normalText}>{data?.template?.resource_persons?.map((d, index) =>
                index === data?.template?.resource_persons?.length - 1 ? `${d.name?.toUpperCase()}, ${d.designation?.toUpperCase()}` : `${d.name?.toUpperCase()}, ${d.designation?.toUpperCase()} | `)}</td>
            </tr>}

            <tr style={tabledata}>
              <td style={td}>NO. OF PARTICIPANTS</td>
              <td style={textAlign}>{data?.participants ? data.participants : data?.template?.registrations?.length}</td>
            </tr>

            <tr style={tabledata}>
              <td style={td}>SDG NO</td>
              <td style={normalText}>{data?.template?.sdg?.map((d, index) =>
                index === data?.template?.sdg?.length - 1 ? `${d.label.toUpperCase()}` : `${d.label.toUpperCase()},  `)}
              </td>
            </tr>

            {data?.template?.PO && <tr style={tabledata}>
              <td style={td}>{`PO number(s)`}</td>
              <td style={normalText}>{data?.template?.PO?.map((d, index) =>
                index === data?.template?.PO?.length - 1 ? `${d.label.toUpperCase()}` : `${d.label.toUpperCase()},  `)}
              </td>
            </tr>}

             {data?.template?.Charter && <tr style={tabledata}>
              <td style={td}>University Charter</td>
              <td style={normalText}>
               {data?.template?.Charter?.map((d, index) => {
                const label = d.label; // keep as-is to preserve original case
                return (
                  <span key={index}>
                    {label.split(" ").map((char, i) => (
                      <span
                        key={i}
                        style={{ color: option.KeywordCharter.includes(char) ? "red" : "inherit" }}
                      >
                        {char+" "}
                      </span>
                    ))}
                    {index === data?.template?.Charter?.length - 1 ? "" : ", "}
                  </span>
                );
              })}
              </td>
            </tr>}
          </table>

          <h5 className='mb-2'>OBJECTIVE:</h5>
          <div id='Objective' style={{
            fontSize: '2.27vh', width: '100%',
            marginLeft: '10px', outline: 'none', border: 'none'
          }}>
          </div >

          <div style={{ width: '100%' }}>
            {data.Description && <h5 className='mb-2 mt-3'>DESCRIPTION:</h5>}
            <p style={justifyAlign}>{data?.Description}</p>
          </div>

          <h5>OUTCOMES:</h5>
          <div id='outcomes' style={{ fontSize: '2.27vh', width: '100%', marginLeft: '10px', outline: 'none', border: 'none' }} >

            {/* <textarea style={{ fontSize: '13px', textAlign: 'justify', width:'100%', marginLeft:'20px', outline: 'none', height: textAreaHeight, border: 'none' }} ref={textAreaRef} value={data?.outcomes} /> */}
          </div >
        </div>

        {/* /----------------------------------------------------------------------------------------------------------------/ */}


        <div id='SecoundDevision'>
          {data && <div className="pdf-gallary-thumbnail">
            {count>0 && data?.EventsPhotos?.map((element, index) => { 
              if(index <= 5){
                return (
                  <div className='pdf-ing-cont'>
                    <img className='pdf-img'
                      id={`${index}`}
                      src={`${images[element?.imageUrl].url}`}
                      alt="Uploaded_Image" />
                    <p className='pdf-para'>{element?.caption}</p>
                  </div>);
              }
            })}
          </div>}
        </div>


        {/* /------------------------------------------------------------------------------------/ */}

        <div id='ThirdDecvision'>
          {data?.Attendances &&
            <table className='mt-2' style={table}>
              <tr style={headingTabledata}>
                {Object?.keys(data?.Attendances[0])?.map(column => {
                  return <th style={HeadingAligne}>{column}</th>
                })} 
              </tr>
              {
                data?.Attendances?.map((x, index) => {
                  return getData(x, index);
                })
              }
            </table>
          }
        </div>

        {/* /-----------------------------------------------------------------------------------/ */}

      </div>
    </div>)
  }

  else {
    return (<h1><LoadingSpinner /></h1>)
  }
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchLogin: (user) => dispatch({ type: 'LOGIN', data: user })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventReport);


